import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CheckMarkOutlineIcon = createIcon({
  displayName: 'CheckMarkOutlineIcon',
  path: [
    <circle cx='12' cy='12' r='11' stroke='currentColor' strokeWidth='2' />,
    <g clipPath='url(#a)'>
      <path
        fill='currentColor'
        d='m6.94 12.893 2.788 2.832a.914.914 0 0 0 1.307 0l6.028-6.122a.948.948 0 0 0 0-1.328.914.914 0 0 0-1.307 0l-5.37 5.453-2.14-2.163a.914.914 0 0 0-1.307 0 .948.948 0 0 0 0 1.328Z'
      />
    </g>,
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M4 4h16v16H4z' />
      </clipPath>
    </defs>
  ],
  defaultProps: defaultProps
})
